import React, { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { SignInStep } from 'actions';
import useAppNavigate from 'hooks/useAppNavigate';
import { useAppSelector } from 'hooks/useAppSelector';
import NotFoundContact from 'pages/NotFound/NotFoundContact';
import { AppRoutes } from 'routes/routes.enums';

import CreateAccount from './steps/CreateAccount';
import EnterConfirmationCode from './steps/EnterConfirmationCode';
import ForgotPassword from './steps/ForgotPassword';
import SentResetPasswordLink from './steps/SentResetPasswordLink';
import SignIn from './steps/SignIn';

const getPageByStep = (step: SignInStep | null, differentEmail?: boolean) => {
  switch (step) {
    case SignInStep.ForgotPassword:
      return <ForgotPassword />;
    case SignInStep.EnterConfirmationCode:
      return <EnterConfirmationCode />;
    case SignInStep.CreateAccount:
      return <CreateAccount />;
    case SignInStep.SentResetPasswordLink:
      return <SentResetPasswordLink />;
    case SignInStep.NotFoundContact:
      return <NotFoundContact />;
    default:
      return <SignIn differentEmail={differentEmail} />;
  }
};

interface SignInProcessProps {
  differentEmail?: boolean;
}

const SignInProcess = ({ differentEmail }: SignInProcessProps) => {
  const navigator = useAppNavigate();
  const { pathname } = useLocation();
  const currentSignInStep = useAppSelector((state) => state.stages.currentSignInStep);

  useEffect(() => {
    navigator(pathname as AppRoutes, { state: { hfsPortal: true } });
  }, []);

  return getPageByStep(currentSignInStep, differentEmail);
};

export default SignInProcess;
